import "@fontsource/syne/latin-600.css";
import "@fontsource/syne/latin-700.css";
import "@fontsource/manrope/latin-400.css";
import "@fontsource/manrope/latin-500.css";
import "@fontsource/manrope/latin-600.css";
import "@fontsource/manrope/latin-700.css";
import "@fontsource/manrope/latin-800.css";
import "@fontsource/ibm-plex-mono/latin-500.css";
import "@fontsource/ibm-plex-mono/latin-600.css";

import "./styles/tokens.css";
import "./styles/base.css";
import "./styles/ui.css";
import "./styles/shell.css";
import "./styles/home.css";
import "./styles/automations.css";
import "./styles/editor.css";
import "./styles/posts.css";
import "./styles/conversations.css";
import "./styles/people.css";
import "./styles/activity.css";
import "./styles/settings.css";
import "./styles/gate.css";
import "./styles/instagram-preview.css";

import { QueryClientProvider } from "@tanstack/react-query";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { RouterProvider } from "react-router/dom";
import { queryClient } from "./api/queries";
import { ToastHost } from "./app/toast";
import { router } from "./router";

const root = document.getElementById("root");
if (!root) throw new Error("The page has no #root to mount the panel on");

createRoot(root).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
      <ToastHost />
    </QueryClientProvider>
  </StrictMode>,
);
